import React from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import ControlBar from "../sections/sideBars/controlBar";
import ControlUsers from "../Controls/Users/ControlUsers";
import ControlGroups from "../Controls/Groups/ControlGroups";
import CarsBar from "../sections/sideBars/carsBar";
import { withCompanyGroups } from "../../shared/containers/containerCompanyGroups";
import ReportContructor from "../Controls/ReportContructor/ReportContructor";
import WinterUnits from "../Controls/WinterUnits/WinterUnits";
import WinterUnitsBar from "../Controls/WinterUnits/WinterUnitsBar/WinterUnitsBar";
import UserUnitsBar from "../Controls/Users/UserUnitsBar/UserUnitsBar";
import { withUsers } from "../../shared/containers/containerUsers";
import { withAuth } from "../../shared/containers/containerAuth";
import ControlDrivers from "../Controls/Drivers/ControlDrivers";
import { withDrivers } from "../../shared/containers/containerDrivers";
import DriverUnitsBar from "../Controls/Drivers/DriverUnitsBar/DriverUnitsBar";

const ControlContent = (props) => {
  const { selectedGroup, currentUser, data, driverForUnits } = props;
  const userUnitsIsView = currentUser !== null && data.permissions.includes(43001);

  const getBar = () => {
    if (selectedGroup !== null) {
      return <CarsBar />;
    }

    if (userUnitsIsView) {
      return <UserUnitsBar />;
    }

    if (driverForUnits !== null) {
      return <DriverUnitsBar />;
    }

    return <ControlBar />;
  };

  return (
    <div>
      <Switch>
        <Route
          exact
          path={[
            "/controls",
            "/controls/groups",
            "/controls/groups/:id",
            "/controls/reportConstructor",
            "/controls/reportConstructor/:id",
            "/controls/users",
            "/controls/users/:id",
          ]}
        >
          <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
            <div className={styles.container_sideBar}>{getBar()}</div>
            <div className={styles.container_sideContent}>
              <Switch>
                <Route exact path={["/controls/groups", "/controls/groups/:id"]} component={ControlGroups} />
                <Route exact path={["/controls/reportConstructor", "/controls/reportConstructor/:id"]} component={ReportContructor} />
                <Route exact path={["/controls/users", "/controls/users/:id"]} component={ControlUsers} />
              </Switch>
            </div>
          </div>
        </Route>
      </Switch>

      <Switch>
        <Route exact path={["/winter/units", "/winter/units/groups/:id"]}>
          <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
            <div className={styles.container_sideBar}>
              <WinterUnitsBar />
            </div>
            <div className={styles.container_sideContent}>
              <Switch>
                <Route exact path={["/winter/units", "/winter/units/groups/:id"]} component={WinterUnits} />
              </Switch>
            </div>
          </div>
        </Route>
      </Switch>

      <Switch>
        <Route exact path={["/controls/drivers", "/controls/drivers/:id"]}>
          <div className={props.isSideBarOpen ? styles.content : styles.content_closedBar}>
            <div className={styles.container_sideBar}>{getBar()}</div>

            <div className={styles.container_sideContent}>
              <Switch>
                <Route exact path={["/controls/drivers", "/controls/drivers/:id"]} component={ControlDrivers} />
              </Switch>
            </div>
          </div>
        </Route>
      </Switch>
    </div>
  );
};

export default withDrivers(withAuth(withUsers(withCompanyGroups(React.memo(ControlContent)))));
